var map = {
	"./1.jpg": 1252,
	"./10.jpg": 4562,
	"./11.jpg": 830,
	"./2.jpg": 9988,
	"./3.jpg": 5337,
	"./4.jpg": 7352,
	"./5.jpg": 4645,
	"./6.jpg": 2661,
	"./7.jpg": 1533,
	"./8.jpg": 2574,
	"./9.jpg": 4442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8124;